import { useContext } from 'react'
import PropTypes from 'prop-types'
import swal from 'sweetalert2'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import useWebhook from '@hooks/useWebhook'

const confirmDelete = (deleteWebhook, deleteFn) => {
  const deleteWebhookPayload = {
    callbacks: {
      action: deleteFn,

    },
    toastText: 'Webhook Deleted',
  }

  swal
    .fire({
      confirmButtonColor: '#DD6B55',
      confirmButtonText: 'Yes, delete it.',
      icon: 'warning',
      showCancelButton: true,
      text: 'Are you sure? It cannot be recovered.',
      title: 'Delete Webhook?',
    })
    .then(({ value }) => {
      if (value){
        deleteWebhook(deleteWebhookPayload)
      }
    })
}

const WebhookListItem = (props) => {
  const { webhook } = props

  const pageContext = useContext(PageContext)
  const {
    callbacks: {
      deleteWebhook,
    },
  } = pageContext

  const {
    callbacks: {
      createOrEditWebhook,
      deleteWebhook: deleteFn,
    },
    webhook: {
      active,
      secret_key,
      title,
      webhook_version,
    },
  } = useWebhook(webhook)

  return (
    <DashboardModuleListItem
      isChecked={active}
      showCheckbox
      secondaryText={webhook_version}
      title={title}
    >
      <DashboardModuleListItem.TertiaryText>
        {secret_key}
      </DashboardModuleListItem.TertiaryText>

      <DashboardModuleListItem.Actions>
        <DashboardModuleListItem.Icon
          marginRight="medium"
          onClick={() => createOrEditWebhook()}
          type="edit"
        />

        <DashboardModuleListItem.Icon onClick={() => confirmDelete(deleteWebhook, deleteFn)} type="delete" />
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

WebhookListItem.propTypes = {
  webhook: PropTypes.object.isRequired,
}

export default WebhookListItem
